class GroupResponseService {
    createResponse(valid, value, errorCode, errorMessage, groupName) {
        const response = {
            valid: !!valid,
            value,
            name: groupName || '',
            error: null,
        };

        if (!valid) {
            response.error = {
                code: errorCode,
                message: errorMessage,
            };
        }

        return response;
    }
}

export default new GroupResponseService();



// WEBPACK FOOTER //
// ./src/services/GroupResponseService/GroupResponseService.js